import React from 'react';
import './ErrorBoundary.css';
import errorReporter from '../../services/errorReporter.js';
import { MESSAGES } from '../../Context/LocalizationContext.js';
import { shouldReloadForChunk } from './chunkReload.js';

// boundary sits above LocalizationProvider, so read the locale directly
const t = (k) => {
  let loc = 'ru';
  try { loc = localStorage.getItem('esep.locale') === 'kk' ? 'kk' : 'ru'; } catch (e) { /* private mode */ }
  return MESSAGES[k]?.[loc] ?? MESSAGES[k]?.ru ?? k;
};

export function ErrorScreen({ error, inline }) {
  return (
    <div className={inline ? 'eb-root eb-root--inline' : 'eb-root'}>
      <svg className="eb-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z" />
      </svg>
      <h2 className="eb-title">{t('CompErrUnexpected')}</h2>
      <p className="eb-text">
        {t('CompErrReported')}
      </p>

      {process.env.NODE_ENV !== 'production' && error && (
        <div className="eb-details">
          <pre>
            {error.message}
            {'\n\n'}
            {error.stack}
          </pre>
        </div>
      )}

      <div className="eb-actions">
        <button type="button" className="eb-btn eb-btn--primary" onClick={() => window.location.reload()}>
          {t('CompReload')}
        </button>
        <button type="button" className="eb-btn eb-btn--outlined" onClick={() => { window.location.href = '/'; }}>
          {t('CompToHome')}
        </button>
      </div>
    </div>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // a chunk of the previous build is gone after a deploy: reload once instead of reporting
    if (shouldReloadForChunk(error)) {
      window.location.reload();
      return;
    }
    errorReporter.report({
      message: error?.message || String(error),
      stack: error?.stack || null,
      component: errorInfo?.componentStack
        ? errorInfo.componentStack.slice(0, 500)
        : null,
      metadata: {
        type: 'react_error_boundary',
        componentStack: errorInfo?.componentStack || null,
      },
    });
    errorReporter.flush();
  }

  componentDidMount() {
    errorReporter.setupGlobalHandlers();
  }

  render() {
    if (this.state.hasError) {
      return <ErrorScreen error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
